export var LOCATION_STATE_DEFINITIONS = [
    { code: 'GA', name: 'Georgia', slug: 'georgia', aliases: ['ga'] },
    { code: 'NC', name: 'North Carolina', slug: 'north-carolina', aliases: ['nc', 'northcarolina'] },
    { code: 'OH', name: 'Ohio', slug: 'ohio', aliases: ['oh'] },
    { code: 'PA', name: 'Pennsylvania', slug: 'pennsylvania', aliases: ['pa'] },
    { code: 'SC', name: 'South Carolina', slug: 'south-carolina', aliases: ['sc', 'southcarolina'] },
];
var normalizeSlug = function (value) {
    if (value === void 0) { value = ''; }
    return (String(value || '')
        .trim()
        .toLowerCase()
        .replace(/_/g, '-')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-'));
};
var LOCATION_STATE_BY_CODE = new Map(LOCATION_STATE_DEFINITIONS.map(function (state) { return [state.code.toUpperCase(), state]; }));
var LOCATION_STATE_BY_SLUG = new Map();
LOCATION_STATE_DEFINITIONS.forEach(function (state) {
    var canonicalSlug = normalizeSlug(state.slug);
    LOCATION_STATE_BY_SLUG.set(canonicalSlug, state);
    LOCATION_STATE_BY_SLUG.set(normalizeSlug(state.code), state);
    LOCATION_STATE_BY_SLUG.set(normalizeSlug(state.name), state);
    (state.aliases || []).forEach(function (alias) {
        LOCATION_STATE_BY_SLUG.set(normalizeSlug(alias), state);
    });
});
export var getLocationStateByCode = function (code) {
    if (code === void 0) { code = ''; }
    if (!code)
        return null;
    return LOCATION_STATE_BY_CODE.get(String(code).trim().toUpperCase()) || null;
};
export var getLocationStateBySlug = function (slug) {
    if (slug === void 0) { slug = ''; }
    if (!slug)
        return null;
    return LOCATION_STATE_BY_SLUG.get(normalizeSlug(slug)) || null;
};
export var getLocationStatePathByCode = function (code) {
    if (code === void 0) { code = ''; }
    var state = getLocationStateByCode(code);
    if (!state)
        return '/truck-parking';
    return "/truck-parking/".concat(state.slug);
};
export var getLocationStatePathBySlug = function (slug) {
    if (slug === void 0) { slug = ''; }
    var state = getLocationStateBySlug(slug);
    if (!state)
        return '/truck-parking';
    return "/truck-parking/".concat(state.slug);
};
export default {
    LOCATION_STATE_DEFINITIONS: LOCATION_STATE_DEFINITIONS,
    getLocationStateByCode: getLocationStateByCode,
    getLocationStateBySlug: getLocationStateBySlug,
    getLocationStatePathByCode: getLocationStatePathByCode,
    getLocationStatePathBySlug: getLocationStatePathBySlug,
};
